import { gql } from 'apollo-boost'
import React, { useContext, useState } from 'react'
import { Button, TextInput, View, ThemeContext, H2, Center } from '~/pagui'
import { wpClient } from '../App'
import { css } from '@emotion/native'
import { LG_SIZE } from '~/pagui/components/View'

type FormType = {
  author: string
  comment: string
}

type Props = { commentOn: string }

const blockForm = css({
  backgroundColor: '#F5F5EB',
})
const inputStyle = css({
  backgroundColor: 'white',
  paddingTop: 20,
  paddingLeft: 12,
  borderColor: '#C4C4C4',
  borderWidth: 1,
  borderStyle: 'solid',
  borderRadius: 5,
  fontSize: '1.6rem',
  fontFamily: 'Montserrat-Regular',
})

const CommentForm: React.FunctionComponent<Props> = ({ commentOn }) => {
  const [theme] = useContext(ThemeContext)
  const [form, setForm] = useState<FormType>({
    author: '',
    comment: '',
  })
  const handleSubmit = async () => {
    console.log({ ...form, commentOn: commentOn })
    const res = await wpClient.mutate<any>({
      mutation: CREATE_COMMENT,
      variables: { ...form, commentOn: commentOn },
    })
    console.log(res)
  }

  return (
    <>
      <View
        minShowSize={LG_SIZE}
        style={[blockForm, theme.styles.p5, theme.styles.mt5, theme.styles.mb5]}
      >
        <Center>
          <H2 style={[theme.styles.mb5, theme.styles.mt3, {textAlign : 'center'}]}>
            Laissez un commentaire
          </H2>
        </Center>
        <View style={{ width: '80%', margin: 'auto' }}>
          <TextInput
            style={[
              inputStyle,
              theme.styles.m1,
              theme.styles.p2,
              { fontFamily: 'Montserrat-Regular' },
            ]}
            placeholder="Votre nom*"
            value={form.author}
            onChangeText={(author) => setForm({ ...form, author })}
          />
          <TextInput
            multiline
            style={[theme.styles.m1, inputStyle]}
            placeholder="Votre commentaire*"
            value={form.comment}
            onChangeText={(comment) => setForm({ ...form, comment })}
          />
          <View
            style={[{ width: 200, alignSelf: 'flex-end' }, theme.styles.mt2]}
          >
            <Button title="Envoyer" onPress={handleSubmit} />
          </View>
        </View>
      </View>
      <View
        maxShowSize={LG_SIZE}
        style={[
          blockForm,
          theme.styles.pb5,
          theme.styles.pt4,
          theme.styles.mt5,
          theme.styles.mb5
        ]}
      >
        <Center>
          <H2
            style={[
              theme.styles.mb3,
              theme.styles.mt3,
              { textAlign: 'center', fontSize: 30, lineHeight: 30 },
            ]}
          >
            Laissez un commentaire
          </H2>
        </Center>
        <View style={{ width: '90%', margin: 'auto' }}>
          <TextInput
            style={[
              theme.styles.m1,
              theme.styles.p2,
              { fontFamily: 'Montserrat-Regular' },
            ]}
            placeholder="Votre nom*"
            value={form.author}
            onChangeText={(author) => setForm({ ...form, author })}
          />
          <TextInput
            multiline
            style={[theme.styles.m1, inputStyle]}
            placeholder="Votre commentaire*"
            value={form.comment}
            onChangeText={(comment) => setForm({ ...form, comment })}
          />
          <View style={[{ width: 200, alignSelf: 'center' }, theme.styles.mt2]}>
            <Button title="Envoyer" onPress={handleSubmit} />
          </View>
        </View>
      </View>
    </>
  )
}

export default CommentForm

const CREATE_COMMENT = gql`
  mutation CreateComment(
    $commentOn: Int!
    $author: String!
    $comment: String!
  ) {
    createComment(
      input: {
        clientMutationId: "CreateComment"
        commentOn: $commentOn
        content: $comment
        author: $author
      }
    ) {
      success
      comment {
        id
        content
        author {
          node {
            name
          }
        }
      }
    }
  }
`
